/// <reference path="../_references.ts"/>

module App.ItemManagement {

	export class ItemManagementService {
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants
		) {

		}

		GetServiceableItemList(): ng.IHttpPromise<ServiceableItem[]> {
			return this.$http.get(`${this.Constants.apiUrl}serviceableitem`);
		}

		GetServiceableItemListByCustomer(customerId: number, addressId: number): ng.IHttpPromise<ServiceableItem[]> {
			return this.$http.get(`${this.Constants.apiUrl}serviceableitem?customer=${customerId}&address=${addressId}&orderBy=id`);
		}

		GetServiceableItem(serviceableItemId: number): ng.IHttpPromise<ServiceableItem> {
			return this.$http.get(`${this.Constants.apiUrl}serviceableitem/${serviceableItemId}`);
		}

		GetServiceableItemTypes(): ng.IHttpPromise<ServiceableItemType[]> {
			return this.$http.get(`${this.Constants.apiUrl}serviceableitemtype`);
		}

		GetServiceableItemType(serviceableTypeItemId: number): ng.IHttpPromise<ServiceableItemType> {
			return this.$http.get(`${this.Constants.apiUrl}serviceableitemtype/${serviceableTypeItemId}`);
		}

		getItemTypeForItem(itemId: number, params?: any): ng.IHttpPromise<ServiceableItemType> {
			return this.$http.get(`${this.Constants.apiUrl}serviceableitem/${itemId}/type`, {
				params: params || {}
			});
		}

		CreateServiceableItem(serviceableitem: ServiceableItemCreate): ng.IHttpPromise<ServiceableItem> {
			return this.$http.post(`${this.Constants.apiUrl}serviceableitem`, serviceableitem);
		}

		UpdateServiceableItem(serviceableitem: ServiceableItem): ng.IHttpPromise<ServiceableItem> {
			return this.$http.put(`${this.Constants.apiUrl}serviceableitem/${serviceableitem.id}`, serviceableitem);
		}

		GetServiceableItemTags(): ng.IHttpPromise<ServiceableItemTag[]> {
			return this.$http.get(`${this.Constants.apiUrl}serviceableitemtag`, {
				params: {
					sort: 'ASC',
					orderBy: 'tag_group'
				}
			});
		}

		CreateServiceableItemNote(serviceableItemId: number, note: ServiceableItemNote): ng.IHttpPromise<ServiceableItemNote> {
			return this.$http.post(`${this.Constants.apiUrl}serviceableitem/${serviceableItemId}/note`, note);
		}

		UpdateServiceableItemNote(serviceableItemId: number, note: ServiceableItemNote): ng.IHttpPromise<ServiceableItemNote> {
			return this.$http.put(`${this.Constants.apiUrl}serviceableitem/${serviceableItemId}/note/${note.id}`, {description: note.description});
		}

		GetServiceableItemNotes(serviceableItemId: number): ng.IHttpPromise<ServiceableItemNote[]> {
			return this.$http.get(`${this.Constants.apiUrl}serviceableitem/${serviceableItemId}/note`);
		}

		DeleteServiceableItemNote(serviceableItemId: number, noteId: number): ng.IHttpPromise<ServiceableItemNote[]> {
			return this.$http.delete(`${this.Constants.apiUrl}serviceableitem/${serviceableItemId}/note/${noteId}`);
		}

		DeleteServiceableItemImage(serviceableItemId: number, imageId: number): ng.IHttpPromise<ServiceableItemImage[]> {
			return this.$http.delete(`${this.Constants.apiUrl}serviceableitem/${serviceableItemId}/image/${imageId}`);
		}

		AddServiceRequest(serviceableItemId: number, srId: number): ng.IHttpPromise<{ success: boolean }> {
			return this.$http.post(`${this.Constants.apiUrl}serviceableitem/${serviceableItemId}/servicerequest`, {
				service_request: srId
			});
		}

		RemoveServiceRequest(ServiceableItemId: number, srId: number): ng.IHttpPromise<{ success: boolean }> {
			return this.$http.delete(`${this.Constants.apiUrl}serviceableitem/${ServiceableItemId}/servicerequest`,  {data: {service_request: srId}});
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new ItemManagementService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}